/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_LocationInputs */

const en_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const ar_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموقع`)
};

const bn_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লোকেশন`)
};

const de_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const es_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const fr_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieu`)
};

const pt_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

const zh_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const tr_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konum`)
};

const ru_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Местоположение`)
};

const pl_image_inspector_location = /** @type {(inputs: Image_Inspector_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Image_Inspector_LocationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_location = /** @type {((inputs?: Image_Inspector_LocationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_LocationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_location(inputs)
	if (locale === "bn") return bn_image_inspector_location(inputs)
	if (locale === "de") return de_image_inspector_location(inputs)
	if (locale === "es") return es_image_inspector_location(inputs)
	if (locale === "fr") return fr_image_inspector_location(inputs)
	if (locale === "pt") return pt_image_inspector_location(inputs)
	if (locale === "zh") return zh_image_inspector_location(inputs)
	if (locale === "tr") return tr_image_inspector_location(inputs)
	if (locale === "ru") return ru_image_inspector_location(inputs)
	if (locale === "pl") return pl_image_inspector_location(inputs)
	return en_image_inspector_location(inputs)
});